module.exports = __webpack_public_path__ + "img/lf5.03cc60d0.png";